import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'mprd-download-mobile',
  templateUrl: './download-mobile.component.html',
  styleUrls: ['./download-mobile.component.css'],
})
export class DownloadMobileComponent {
  @Output() toggleView: EventEmitter<void> = new EventEmitter();

  constructor() {}

  public click() {
    this.toggleView.emit();
  }
}
